// extracted by mini-css-extract-plugin
export default {"container":"UserLookupForm_container__QMHvY","wrapper":"UserLookupForm_wrapper__3H+4c","title":"UserLookupForm_title__fJjwd","form":"UserLookupForm_form__9Udkx"};